import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component    from './home.component'

import HomeSlider       from './slider'
import HomeDescription  from './description'

let module = angular.module('home', [
  uiRouter,
  HomeSlider,
  HomeDescription
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject'

  $urlRouterProvider.otherwise('/')

  $stateProvider
    .state('home', {
      url: '/',
      component: 'home',
      params: {
        redirect: null,
        redirectParams: null
      },
      myRenaultForbidden: true,
      authenticatedForbidden: true
    })
})
.component('home', component)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/home/index.js